<template>
  <div v-if="hasContent" class="employee-assignments-badge">
    <template v-if="primaryPositionName">
      <Icon name="primary_icon" class="employee-assignments-badge__icon" />
      <span class="employee-assignments-badge__label">{{ primaryPositionName }}</span>
    </template>

    <span
      v-if="primaryPositionName && preparingForPositionName"
      class="employee-assignments-badge__chevron"
      aria-hidden="true"
    >
      <img :src="chevronRightIcon" alt="" />
    </span>

    <template v-if="preparingForPositionName">
      <Icon name="preparing_for_icon" class="employee-assignments-badge__icon" />
      <span class="employee-assignments-badge__label">{{ preparingForPositionName }}</span>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";

import Icon from "@components/icons/Icon.vue";
import chevronRightIcon from "./icons/chevron-right.svg";

const props = defineProps({
  primaryPositionName: {
    type: String,
    default: "",
  },
  preparingForPositionName: {
    type: String,
    default: "",
  },
});

const hasContent = computed(
  () => Boolean(props.primaryPositionName || props.preparingForPositionName)
);
</script>

<style scoped>
.employee-assignments-badge {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  flex-shrink: 0;
}

.employee-assignments-badge__icon {
  display: flex;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.employee-assignments-badge__chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.employee-assignments-badge__chevron img {
  display: block;
  width: 8px;
  height: 14px;
}

.employee-assignments-badge__label {
  font-family: Inter, sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 20px;
  color: #475467;
  white-space: nowrap;
}
</style>
